import React, { isValidElement, useMemo } from 'react'
import styles from './index.module.css'
import { FieldsetContext } from '../context'
import { extractNames, hasDisplayName } from '@s4l/utils/library/react'

interface IFieldsetProps {
  children: React.ReactNode
}

const Fieldset = ({ children }: IFieldsetProps) => {
  const childrenArray = React.Children.toArray(children)

  const { legends, buttons, otherChildren, names } = useMemo(() => {
    const l: React.ReactNode[] = []
    const b: React.ReactNode[] = []
    const c: React.ReactNode[] = []

    childrenArray.forEach(child => {
      if (isValidElement(child) && typeof child.type === 'function' && hasDisplayName(child.type)) {
        if (child.type.displayName === 'Form.Legend') {
          l.push(child)
        } else if (child.type.displayName === 'Form.ClearButton') {
          b.push(child)
        } else {
          c.push(child)
        }
      } else {
        c.push(child)
      }
    })

    const n = extractNames(c)

    return { legends: l, buttons: b, otherChildren: c, names: n }
  }, [childrenArray])

  const showLegend = legends.length > 0 || buttons.length > 0

  const contextValue = useMemo(() => ({ isInsideFieldset: true, inputs: names }), [names])

  return (
    <FieldsetContext.Provider value={contextValue}>
      <fieldset className={styles.fieldset} name="fieldset">
        {showLegend && (
          <div className={styles.legendWrapper}>
            {legends}
            {buttons}
          </div>
        )}
        {otherChildren}
      </fieldset>
    </FieldsetContext.Provider>
  )
}

Fieldset.displayName = 'Form.Fieldset'
export default Fieldset
